import axios from 'axios';

const API_URL = "https://dittmagasin.no/api/v2";

const userService = {
  getProfile: async (userId) => {
    try {
      const response = await fetch(`${API_URL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': 'gd54m8auqgn7j3llo'
        },
        body: JSON.stringify({
          user_id: userId,
        })
      });
      return await response.json();
    } catch (error) {
      console.error("Error fetching profile:", error);
      return null;
    }
  },
  changePassword: async (params, updatedData) => {
    try {
      var postData = {
        'old_password': updatedData.old_password,
        'new_password': updatedData.new_password,
      }

       const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        const res = await axios.post(`${API_URL}/change-password`,
            JSON.stringify(postData),
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
      return res;
      return await res.json();
    } catch (error) {
      console.error(error);
      return await error.json();
    }
  },
};

export default userService;
